module.exports = __webpack_public_path__ + "RMR HSA Investments.pdf";